import config from 'embroil/config/environment';

/**
 * Fixes Twitch player URLs to include the correct parent parameter for the current environment
 * This is essential for Twitch embeds to work in production
 */
export function fixTwitchUrl(originalUrl: string): string {
  try {
    const url = new URL(originalUrl);
    
    // Only process Twitch player URLs
    if (url.hostname !== 'player.twitch.tv') {
      return originalUrl;
    }
    
    // Get the correct parent domain for this environment
    const parentDomain = config.twitchParentUrl || 'localhost';
    
    // Update or add the parent parameter
    url.searchParams.set('parent', parentDomain);
    
    return url.toString();
  } catch (error) {
    // If URL parsing fails, return original URL
    console.warn('Failed to parse Twitch URL:', originalUrl, error);
    return originalUrl;
  }
}

/**
 * Helper to fix multiple Twitch URLs in HTML content
 */
export function fixTwitchUrlsInHtml(html: string): string {
  const twitchUrlRegex = /https:\/\/player\.twitch\.tv\/\?[^"'\s]+/g;
  
  return html.replace(twitchUrlRegex, (match) => {
    return fixTwitchUrl(match);
  });
}